var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-detail-swiper",class:{
		'has-goods-stock': _vm.isStock <= 0
	}},[(_vm.index == 0)?_c('product-info'):_vm._e(),(_vm.index == 1)?_c('product-desc'):_vm._e(),(_vm.index == 2)?_c('product-review'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }